import { z } from "zod";

const UnallocatedSwapSchema = z
  .object({
    id: z.string().uuid(),
    status: z.string(),
    shares: z.string(),
  })
  .passthrough();

export { UnallocatedSwapSchema };
